import React from 'react';
import './ShoutOut.css';

const ShoutOut = () => {
    return (
        <div className="section" id='shout' >
            <div className="container">
                <div className='section-title text-center'>
                    <span className="text-color mb-0 text-uppercase letter-spacing text-sm"> <i className="ti-minus mr-2"></i>FELLAS</span>
                    <h1 className="title">ShoutOut</h1>
                </div>
            </div>
        </div>
    )
}

export default ShoutOut